export default function arraysHaveAtLeastOneCommonItem(arr1: string[] | undefined, arr2:string[] | undefined): boolean {
	if (
		arr1 === undefined || arr1 === null
		|| arr2 === undefined || arr2 === null
	) {
		return false;
	}

	let a1: string[], a2: string[];
	if (arr1.length < arr2.length) {
		a1 = arr1;
		a2 = arr2;
	} else {
		a1 = arr2;
		a2 = arr1;
	}

	return a1.findIndex(item => a2.indexOf(item) !== -1) !== -1;
}
